import { postData, getData, putData, deleteData, patchData } from '../axiosServices'

const customBaseUrl = process.env.REACT_APP_REVIEW_APP_API_URL ? `${process.env.REACT_APP_REVIEW_APP_API_URL}/api/v1/` : undefined;

export const getAllPracticeTopics = async (learner_code) => {
    let url = `learnerTrackScore/${learner_code}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }

    return getData(url, { headers });
};

export const getAllTrackScoreDetails = async (learner_id, topic_id, module_id, makerPlan_id) => {
    let url = `learnerTrackScore/detailedTrackScore?learner_id=${learner_id}&topic_id=${topic_id}&module_id=${module_id}&maker_plan_id=${makerPlan_id}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }

    return getData(url, { headers });
};
export const addPractice = async (obj) => {
    let url = `learnerTrackScore`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, obj, { headers });
};
export const getLearnerNotes = async (learner_id, makerPlan_id, module_id, topic_id) => {
    let url = `learnerTrackNote/learners/${learner_id}/makerplan/${makerPlan_id}/modules/${module_id}/topics/${topic_id}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers });
};
export const addLearnerNotes = async (obj) => {
    let url = `learnerTrackNote`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return postData(url, obj, { headers });
};
export const updateLearnerNotes = async (note_id, obj) => {
    let url = `learnerTrackNote/${note_id}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, obj, { headers });
};
export const DeleteLearnerNotes = async (note_id) => {
    let url = `learnerTrackNote/${note_id}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return deleteData(url, { headers });
};

export const getLearnerList = (coeID, labID) => {
    let url;
    if (labID) {
        url = `learners/coeId/${coeID}/labId/${labID}`;
    } else {
        url = `coe/${coeID}/learners`;
    }
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers });
};
export const updatePublished = async (learner_id, makerPlan_id, module_id, topic_id, obj) => {
    let url = `learnerTrackScore/learners/${learner_id}/makerplan/${makerPlan_id}/modules/${module_id}/topics/${topic_id}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, obj, { headers });
};

export const PracticeStatus = Object.freeze({
    IN_PROGRESS: 'IN_PROGRESS',
    EVALUATION_PENDING: 'EVALUATION_PENDING',
    EVALUATION_FAILED: 'EVALUATION_FAILED',
    COMPLETED: 'COMPLETED',
});

export const getMentorPracticesDashboard = async (paramsOrCoe, lab_id, page = 1, limit = 10, additionalFilters = {}) => {
    let paramsObj = {};
    if (typeof paramsOrCoe === 'object' && paramsOrCoe !== null) {
        paramsObj = { ...paramsOrCoe };
    } else {
        paramsObj = {
            coe_id: paramsOrCoe,
            lab_id: lab_id,
            page: page,
            limit: limit,
            ...additionalFilters
        };
    }

    if (paramsObj.coeId && !paramsObj.coe_id) {
        paramsObj.coe_id = paramsObj.coeId;
    }
    delete paramsObj.coeId;

    const queryParams = new URLSearchParams();
    Object.keys(paramsObj).forEach(key => {
        const val = paramsObj[key];
        if (val !== undefined && val !== null && val !== '' && val !== 'all') {
            queryParams.append(key, val);
        }
    });

    let url = `mentor-practice/learner-practices?${queryParams.toString()}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers }, customBaseUrl);
};

export const getSubmissionDetails = async (learnerId, practiceProgressId) => {
    let url = `mentor-practice/learners/${learnerId}/practices/${practiceProgressId}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers }, customBaseUrl);
};

export const saveMentorFeedback = async (learnerId, practiceProgressId, payload) => {
    let url = `mentor/learners/${learnerId}/reviews/${practiceProgressId}/score`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return patchData(url, payload, { headers }, customBaseUrl);
};

export const verifyMentorPractices = async (payload) => {
    let url = `mentor/reviews/verify`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return postData(url, payload, { headers }, customBaseUrl);
};

export const uploadLCScores = async (formData) => {
    let url = `mentor/lc-scores/upload`;
    const headers = {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return postData(url, formData, { headers }, customBaseUrl);
};

export const getTlcScores = async (practiceId, learnerId) => {
    let url = `tlc/details?reviewId=${practiceId}&learnerId=${learnerId}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers }, customBaseUrl);
};

export const getPracticeNames = async () => {
    let url = `mentor-practice/practice-names`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers }, customBaseUrl);
};
